/**
 * Method adds protocol to URLs which start with // (without proper protocol)
 * @function addHttpsProtocol
 * @param {string} url
 * @returns {string|*}
 */
export default function addHttpsProtocol(url: string): string {
  if (typeof url !== 'string') {
    return url;
  }

  if (url.startsWith('//')) {
    return `https:${url}`;
  }

  return url;
}
